import React from 'react';
import { Button } from './ui/Button';

const ThemeToggle = ({ darkMode, toggleTheme }) => (
  <Button
    variant="ghost"
    size="icon"
    icon={darkMode ? 'bi-sun' : 'bi-moon'}
    onClick={toggleTheme}
    title={darkMode ? 'Светлая тема' : 'Тёмная тема'}
    aria-label={darkMode ? 'Переключить на светлую тему' : 'Переключить на тёмную тему'}
  />
);

export default ThemeToggle;
